import { makeAutoObservable, toJS } from 'mobx'

import { ExcursionsList } from 'shared/api/excursions'
import {
  IExcursionDetails,
  IExcursionsFilters,
  IExcursionsList,
  IFindExcursionsList,
} from 'shared/api/excursions/list/model'

import { IFindExcursionsFilter } from '../find-excursions/models'

class ListExcursionStore {
  excursionsList: IExcursionsList[] | null = null
  excursionsFilter: IExcursionsFilters | null = null
  page: number = 1
  maxPage: number = 1

  loading: boolean = false

  currentExcursionsDetail: IExcursionDetails | null = null

  constructor() {
    makeAutoObservable(this)
  }

  onSetCurrentExcursionsDetail(excursions: IExcursionDetails | null) {
    this.currentExcursionsDetail = excursions
  }
  onSetExcursions(excursions: IExcursionsList[]) {
    this.excursionsList = excursions
  }

  onSetExcursionsFilters(excursions: IFindExcursionsList) {
    this.excursionsFilter = {
      ...excursions,
    }
  }

  resetList() {
    this.excursionsList = null
    this.excursionsFilter = null
    this.page = 1
    this.maxPage = 1

    this.loading = false
  }

  getGuides() {
    return toJS(this.excursionsFilter?.guides)
  }

  async onGetExcursions(params: IFindExcursionsFilter | undefined) {
    this.loading = true

    try {
      const { data: response } = await ExcursionsList.getExcursionsList(
        params,
        this.page,
      )

      const { excursions, guides, price_range, excursion_types } = response.data
      const { total_pages } = response

      this.page = this.page + 1

      this.maxPage = total_pages || 1

      this.onSetExcursionsFilters({
        guides,
        price_range,
        excursion_types,
        excursions,
      })
      this.onSetExcursions(excursions)
    } catch (err) {
    } finally {
      this.loading = false
    }
  }
}

export const listExcursionStore = new ListExcursionStore()
